export const headerSearchInputStyles = {
  form: 'relative flex min-w-0 w-full items-center gap-2',
  formCompactClosed: 'max-[419px]:hidden',
  inputWrap: 'group/search relative min-w-0 w-full',
  input:
    'h-11 min-w-0 w-full appearance-none rounded-md border border-border-subtle bg-bg-canvas pl-10 pr-10 text-base text-fg-primary placeholder:text-fg-muted transition-colors focus:border-accent focus:outline-none focus:ring-4 focus:ring-accent/15 [&::-webkit-search-cancel-button]:hidden',
  inputIcon:
    'pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-fg-muted group-focus-within/search:text-accent',
  iconGlyph: 'h-4 w-4 shrink-0',
  iconButton:
    'inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-fg-secondary hover:bg-bg-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  clearInput:
    'absolute right-0 top-0 inline-flex h-11 w-10 items-center justify-center rounded-md text-fg-muted hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
} as const;
